export const cilTransfer = ["24 24","<path d='M16.72 10.72l1.061 1.061 5.405-5.405-5.405-5.405-1.061 1.061 3.595 3.595h-19.564v1.5h19.564l-3.595 3.595z'></path><path d='M23.25 16.875h-19.564l3.595-3.595-1.061-1.061-5.405 5.405 5.405 5.405 1.061-1.061-3.595-3.595h19.564v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-transfer.js
// module id = null
// module chunks = 